export class UndefinedEnvironmentError extends Error {
  constructor(public readonly envName: string) {
    super(`process.ENV.${envName} undefined`);
  }
}
